import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  FETCH_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_SUCCESS,
  SAVE_NOTIFICATION_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_NOTIFICATION_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_NOTIFICATION_QUERY,
    query
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_NOTIFICATION_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {notification} = store.getState();
      const {query} = notification;
      const response = await axios.get(`/notification?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {notification} = store.getState();
      const {query} = notification;
      const response = await axios.get(`/notification/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/notification/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

